import {useState} from 'react';

import {
  useDeletePhotoMutation,
  useSetVehicleAlbumCoverPhotoMutation,
  useUnsetVehicleAlbumCoverPhotoMutation,
} from '@dms/api/sales';

import {handleApiError} from '../../../utils/handleApiError';
import {ServiceCasePhotoTile} from '../types/ServiceCasePhotoTile';

interface UseServiceCasePhotoActionsProps {
  vehicleId: string;
}

export function useServiceCasePhotoActions(props: UseServiceCasePhotoActionsProps) {
  const [processingPhotoIds, setProcessingPhotoIds] = useState<string[]>([]);

  const [setCoverPhoto] = useSetVehicleAlbumCoverPhotoMutation();
  const [unsetCoverPhoto] = useUnsetVehicleAlbumCoverPhotoMutation();
  const [deletePhoto] = useDeletePhotoMutation();

  const startProcessing = (photoId: string) => setProcessingPhotoIds((prev) => [...prev, photoId]);

  const stopProcessing = (photoId: string) =>
    setProcessingPhotoIds((prev) => prev.filter((id) => id !== photoId));

  const setPhotoAsCover = (photo: ServiceCasePhotoTile) => {
    startProcessing(photo.id);
    setCoverPhoto({
      vehicleId: props.vehicleId,
      vehicleAlbumId: photo.albumId,
      vehiclePhotoId: photo.id,
    })
      .unwrap()
      .catch(handleApiError)
      .finally(() => stopProcessing(photo.id));
  };

  const unsetPhotoAsCover = (photo: ServiceCasePhotoTile) => {
    startProcessing(photo.id);
    unsetCoverPhoto({
      vehicleId: props.vehicleId,
      vehicleAlbumId: photo.albumId,
    })
      .unwrap()
      .catch(handleApiError)
      .finally(() => stopProcessing(photo.id));
  };

  const deleteAlbumPhoto = (photo: ServiceCasePhotoTile) => {
    startProcessing(photo.id);
    deletePhoto({
      vehicleId: props.vehicleId,
      albumId: photo.albumId,
      vehiclePhotoDeleteRequestBody: {photos: [{fileId: photo.fileId}]},
    })
      .unwrap()
      .catch(handleApiError)
      .finally(() => stopProcessing(photo.id));
  };

  return {
    setPhotoAsCover,
    unsetPhotoAsCover,
    deleteAlbumPhoto,
    processingPhotoIds,
  };
}
